
export default {
    name: 'constantes',
    components: {},
    props: ["consultation_id", "hn", "constante_a_prendre", "constantes_prises", "jn"],
    data() {
        return {
            cste_loading: true,
        }
    },

    watch: {
        constantes_prises() {
            this.reloadConstanteHn()
        }
    },

    computed: {
        /**
         * Get constantes
         * @returns 
         */
        soins_h0_constantes() {
            return this.$store.getters["soins_h0_constantes"]
        },
    },

    mounted() {
        // this.getConstanteEnH0()
        this.reloadConstanteHn()
    },

    methods: {
        getConstanteEnH0() {
            this.$store.dispatch('getConstanteSoinsH0', this.consultation_id)
        }, 

        reloadConstanteHn() {
            this.cste_loading = true

            setTimeout(() => {
                this.cste_loading = false
            }, 500);
            this.getConstanteEnH0()
        }
    }
}